import createAxios from "./axiosHttp";

function normalizeAddress(body) {
  const axios = createAxios();
  const urlPath = "ttmm/maps/address/normalize";
  return axios.post(urlPath, body);
}

export const mapsService = {
  normalizeAddress,
};
